import { useQuery } from '@tanstack/react-query';

import { signatureApi } from '../axios';

export function useUserFormSignatureInfoQuery(formAnswerId: string) {
  return useQuery({
    queryKey: ['userFormSignatureInfo', formAnswerId],
    queryFn: () => signatureApi.getUserFormSignInfo(formAnswerId),
    enabled: !!formAnswerId,
  });
}

export function useUserSignatureStateQuery() {
  return useQuery({
    queryKey: ['userSignatureState'],
    queryFn: () => signatureApi.getUserSignatureState(),
  });
}

export function useCompletedSignaturesQuery(formAnswerId: string) {
  return useQuery({
    queryKey: ['completedSignatures', formAnswerId],
    queryFn: () => signatureApi.getFormAnswerCompletedSignatures(formAnswerId),
    enabled: !!formAnswerId,
  });
}

export function usePendingSignaturesCountQuery() {
  return useQuery({
    queryKey: ['pendingSignaturesCount'],
    queryFn: () => signatureApi.getPendingSignaturesCount(),
    select: (data) => data.pending_signatures,
  });
}

export function useExternalUserFormSignatureInfoQuery(token: string) {
  return useQuery({
    queryKey: ['externalUserFormSignatureInfo', token],
    queryFn: () => signatureApi.getExternalUserFormSignInfo(token),
    enabled: !!token,
  });
}

export function useImplementationRequestDateQuery() {
  return useQuery({
    queryKey: ['implementationRequestDate'],
    queryFn: () => signatureApi.getImplementationRequestDate(),
  });
}
